import React__default from 'react';
import { M as MenuItemButton } from '../../../Menu/MenuItem/MenuItemButton-Dt1kHi0m.js';

const SplitButtonItem = props => /*#__PURE__*/React__default.createElement(MenuItemButton, props);

export { SplitButtonItem as S };
//# sourceMappingURL=SplitButtonItem-cZ9g_Jxx.js.map
